// The words View options and the resize boundaries show and announce.

export const VIEW_COPY = {
  trigger: 'View options',
  density: 'Density',
  comfortable: 'Comfortable',
  compact: 'Compact',
  densityChanged: 'Density changed',
  densityFailed: 'Could not change density',
  columns: 'Columns',
  resetWidths: 'Reset column widths',
  widthsReset: 'Column widths reset',
  reorderHint: 'Alt+Up Arrow or Alt+Down Arrow moves the column.',
}

export const reorderLabel = column => `Reorder ${column.label}`

export const showLabel = column => `Show ${column.label}`

export const visibilityResult = (column, visible) =>
  `${column.label} ${visible ? 'shown' : 'hidden'}`

export const visibilityFailed = column => `Could not change ${column.label}`

export const movedText = (column, position, count) =>
  `${column.label} moved to position ${position} of ${count}`

export const resizeLabel = column => `Resize ${column.label} column`

export const widthText = width => `${width} pixels`
